
import Vue from 'vue';

export default () => (
  new Promise((resolve, reject) => {
    Vue.$http.get('woocommerce')
    .then((response) => {
      resolve(response.data.data);
    })
    .catch((error) => {
      reject(error);
    });
  })
);



// WEBPACK FOOTER //
// ./src/app/services/account/wooCredentials.js